import type { SVGProps } from 'react';

const SvgRaApprovalRequestedToMe = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M11.69 20.898H8c-1.65 0-3-1.35-3-3v-8.32c0-1.38.73-2.69 1.91-3.41l4.53-2.76c.94-.57 2.07-.6 3.03-.06A2.97 2.97 0 0 1 16 5.968v4.91l.26-.22c1.03-.85 2.51-.79 3.46.16.92.92 1.01 2.39.19 3.41l-1.28 1.36-4.11 4.13c-.75.75-1.78 1.18-2.84 1.18z"
    />
  </svg>
);
export default SvgRaApprovalRequestedToMe;
